/* =============================================================
   NOAH'S — Collection Password Gate controller (vanilla JS)
   Reads the password from data attributes (JSON-encoded, so apostrophes
   are safe). Unlock state is stored per collection handle in localStorage.

   This is a marketing gate, not a secure lock — the password is present
   in the page source.
   ============================================================= */
(function () {
  'use strict';

  function init() {
    var gate = document.querySelector('[data-collection-gate]');
    if (!gate) return;

    var handle = gate.getAttribute('data-collection-handle') || '';
    var raw = gate.getAttribute('data-collection-password') || '""';
    var password;
    try { password = JSON.parse(raw); } catch (e) { password = raw; }
    password = String(password);

    var key = 'collection-password-unlocked-v2-' + handle;
    var input = gate.querySelector('[data-cpg-input]');
    var form = gate.querySelector('[data-cpg-form]');
    var error = gate.querySelector('[data-cpg-error]');

    function unlock(persist) {
      if (persist) { try { localStorage.setItem(key, '1'); } catch (e) {} }
      gate.classList.add('is-unlocked');
      gate.classList.add('collection-password-unlocked');
      document.body.classList.remove('has-collection-password-gate');
      document.body.classList.add('collection-password-unlocked');
    }

    function lock() {
      document.body.classList.add('has-collection-password-gate');
      if (input) { try { input.focus(); } catch (e) {} }
    }

    // Let merchants edit the page inside the theme editor without being blocked.
    if (window.Shopify && window.Shopify.designMode) { unlock(false); return; }

    // Already unlocked in a previous visit?
    var already = false;
    try { already = localStorage.getItem(key) === '1'; } catch (e) {}
    if (already) { unlock(false); return; }

    lock();

    function attempt() {
      var val = input ? input.value : '';
      if (val.trim() === password.trim()) {
        if (error) error.setAttribute('hidden', '');
        unlock(true);
      } else {
        if (error) error.removeAttribute('hidden');
        gate.classList.add('is-error');
        if (input) { input.focus(); input.select(); }
        window.setTimeout(function () { gate.classList.remove('is-error'); }, 450);
      }
    }

    if (form) {
      // form submit covers both the button click and Enter inside the input
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        attempt();
      });
    }
    if (input) {
      input.addEventListener('input', function () {
        if (error) error.setAttribute('hidden', '');
      });
    }
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
